<div class="row column" *ngIf="show">
	<h1>{{ getHeadline() | translate }}</h1>
</div>
